import $ from "jquery";
import braintree from 'braintree-web';

let Cognity = {};

const Alerts = {
    yesCaption: "ΝΑΙ",
    noCaption: "ΟΧΙ",
    msgBlock: "",
    showConfirmation: function(yes, no,msgOver, msgUnder, title, callback, keepOpen) {

        $("div.lightbox-holder-confirm").remove();
        let holder = $("<div id='root'><main id='pageContent'><div class='simple-popup'><div" +
            " class='simple-popup-content simple-popup-content-confirm'><div class='lightbox-holder-confirm'><div class='lightbox lightboxMin'" +
            " id='lightbox-confirm'><h2></h2><div class='text'></div><div class='lightboxSelectULHold'><h3></h3><div" +
            " class='bt'><a class='button green-button' id='confYes'><span class='l'>"+yes+"</span><span class='r" +
            " r2'></span></a>&nbsp;<a class='button green-button' id='confNo'><span class='c'>"+no+"</span><span" +
            " class='r r2'></span></a></div></div></div></div></div></div></main></div>");
        $("body").append(holder);
        holder.find("h2").html(title);
        holder.find("h3").html(msgUnder);
        holder.find("div.text").html(msgOver);

        $("#confYes").click(function(){
            if (!keepOpen){
                $("div.lightbox-holder-confirm").remove();
            }
            callback(true);
        });
        $("#confNo").click(function(){
            if (!keepOpen){
                $(".lightbox-holder-confirm").remove();
            }
            callback(false);
        });

        $("#fancybox-close").click(function(){
            if (!keepOpen){
                $("#pageContent").remove();
            }
            callback(false);
        });

        $(document).keyup(function(e) {
            if (e.keyCode === 27) {
                if (!keepOpen){
                    $("#pageContent").remove();
                }
                callback(false);
            }   // esc
        });


        return false;

    },
}

Cognity.Utils = {

    constants : {
        EMAIL_VALIDATION_REGEX : /^([^\s]+@[^\s]+\.[^.]+)$/ // not so good ... : /[^.]+@[^.]+\.[^.]+/
    },

    isEmptyString: function(str){
        if(str){
            if($.trim(str)){
                return false;
            }
        }
        return true;
    },

    isValidEmail : function(email){
        if(Cognity.Utils.isEmptyString(email)){
            return false;
        }
        email = $.trim(email);

        return Cognity.Utils.constants.EMAIL_VALIDATION_REGEX.test(email);
    },

    validatePhone : function(element) {
        var mobile = element.val();
        var patternMobile = /^[6][9][0-9]{8}$/;
        var patternFixed = /^[2][0-9]{9}$/;

        if (patternMobile.test(mobile) || patternFixed.test(mobile)) {
            return true;

        }
        return false;
    },

    validateMobilePhone : function(mobile) {
        var patternMobile = /^[6][9][0-9]{8}$/;
        if (patternMobile.test(mobile)) {
            return true;
        }
        return false;
    },

    validatePin: function(id) {
        /* Will be fixed later. */

        var pin = id;
        var pattern = /^\d{4,7}$/;

        if (pattern.test(pin)) {
            return true;
        }
        return false;
    },

    objectToString : function(obj){
        if(!obj){
            return '';
        }

        var returnStr = "{ ";
        for(var propName in obj) {
            let propValue = obj[propName];
            returnStr += "("+propName + ", "+propValue+"), ";
        }
        if(returnStr.length >= 2){
            returnStr = returnStr.substring(0, returnStr.length-2)+"}";
        }
        return returnStr;
    },

    stringToBoolean : function(myValue){
        // Case insensitive check that will return true in case of a 'true' string and false in all
        // the other cases.
        var isTrue = (myValue.toLowerCase() === 'true');
        return isTrue;
    },

    recursiveStringify : function(obj) {

        if(!obj){
            return '';
        }

        var objKeys = Object.keys(obj);
        var keyValueArray = new Array();
        for (var i = 0; i < objKeys.length; i++) {
            var keyValueString = '"' + objKeys[i] + '":';
            var objValue = obj[objKeys[i]];
            keyValueString = (typeof objValue == "string") ?
                keyValueString = keyValueString + '"' + objValue + '"' :
                keyValueString = keyValueString + Cognity.Utils.recursiveStringify(objValue);
            keyValueArray.push(keyValueString);
        }
        return "{" + keyValueArray.join(",") + "}";
    }

};


export const BraintreePaypal = {

    Constants: {

        Response: {
            SUCCESS: 'SUCCESS',
            GENERAL_ERROR: 'GENERAL_ERROR'
        },

        PaymentMethod: {
            BRAINTREE_PAYPAL: 'BRAINTREE_PAYPAL',
            CREDIT_CARD_NBG: 'CREDIT_CARD_NBG'
        },

        NonVaultedTransactionStep: {
            PAYPAL_BUTTON_NOT_INITIALIZED: "PAYPAL_BUTTON_NOT_INITIALIZED",
            PAYPAL_BUTTON_INITIALIZED: "PAYPAL_BUTTON_INITIALIZED",
            PAYPAL_LOGIN_INITIATED: "PAYPAL_LOGIN_INITIATED",
            PAYPAL_LOGIN_COMPLETED: "PAYPAL_LOGIN_COMPLETED"
            //PAYMENT_VERIFIED : "PAYMENT_VERIFIED", // not used right now
            //PAYMENT_PROCESSED : "PAYMENT_PROCESSED" // not used right now
        },

        VaultedTransactionStep: {
            VAULTED_PAYMENT_UNVERIFIED: "VAULTED_PAYMENT_UNVERIFIED"
            //VAULTED_PAYMENT_VERIFIED : "VAULTED_PAYMENT_VERIFIED", // not used right now
            //VAULTED_PAYMENT_PROCESSED : "VAULTED_PAYMENT_PROCESSED" // not used right now
        },

        PaypalTransactionType: {
            NO_PAYPAL_ALLOWED: "NO_PAYPAL_PAYMENT_ALLOWED",
            NO_VAULT_AT_ALL: "NON_VAULTED_PAYPAL_PAYMENT_ALLOWED",
            VAULT_CREATION: "VAULT_CREATION_PAYPAL_PAYMENT_ALLOWED",
            VAULT_REUSAGE: "VAULTED_PAYPAL_PAYMENT_ALLOWED"

        },

        Channel: {
            AVT: "AVT",
            WHATSUP: "WHATSUP"
        }
    },

    // STATE

    paypalTransactionType: null,
    paypalAccountEmail: null,
    // These depend on the channel:
    preapproveFuturePayments: false,
    paypalLoginButtonElementId: 'paypalLoginButton',
    forcePaymentMethodRadioSelectionHandler: null,

    // Controller actions
    initializePaypalButtonActionURL: null,
    initiatePaypalLoginActionURL: null,
    completePaypalLoginActionURL: null,
    deletVaultActionURL: null,

    /*braintree.setup onReady braintreeInstance*/
    braintreeInstance: null,

    selectedPaymentMethod: null,
    // The paypal login button is not initialized at first (braintree.setup has not run yet).
    // It will run the first time the paypal payment method radio button is selected.
    transactionStep: null,
    mustCompletePaypalLogin: false,
    // onPaymentMethodReceived initializes this:
    paymentDescriptor: null,
    // on braintree.setup ... onReady
    deviceData: null,
    flowId: null,
    key: null,
    paypalSaveEnabled: null,
    paypalClientToken: null,
    vaultDeleteButtonCaption: null,
    vaultDeleteConfirmationMessage: null,
    vaultDeleteConfirmationButtonCaption: null,
    vaultDeleteButtonYes: null,
    vaultDeleteButtonNo: null,
    amount: null,
    // block ui handlers (functions to block and unblock the ui)
    // blockUiHandler : null,
    // unblockUiHandler : null,
    loginFlowLocale: null, // At this point the relevant locales that are supported are: en_us and ru_ru, greek
    // is not
    // supported, if you provide an invalid locale it will default to en_us.
    // To programmatically start the paypal authentication flow use initAuthFlow of this object
    paypal: null,
    // Handler to initialize the paypal login flow programmatically.
    initiatePaypalFlowProgrammatically: function () {

        BraintreePaypal.braintreeInstance.paypal.initAuthFlow();
        if (BraintreePaypal.Constants.NonVaultedTransactionStep.PAYPAL_BUTTON_INITIALIZED === BraintreePaypal.transactionStep) {
            BraintreePaypal.initiatePaypalLogin();
        }

    },

    // INIT
    init: function (
        paypalTransactionType,
        paypalLoginButtonElementId,
        key,
        flowId,
        paypalSaveEnabled,
        paypalClientToken,
        amount,
        paypalAccountEmail,
        vaultDeleteButtonCaption,
        vaultDeleteConfirmationMessage,
        //loginFlowLocale,
        // deletVaultActionURL,
        vaultDeleteConfirmationButtonCaption,
        vaultDeleteButtonYes,
        vaultDeleteButtonNo
    ) {

        //$('input:radio[name="paymentMethod"]').filter('[value="BRAINTREE_PAYPAL"]').prev(".rad-area").addClass( "paymentMethodBRAINTREE_PAYPALCheckBox" );
        //$('input:radio[name="paymentMethod"]').filter('[value="BRAINTREE_PAYPAL"]').prev(".rad-area").addClass( "paymentMethodBRAINTREE_PAYPALshilftClass" );

        // INITIALIZE FIELDS

        BraintreePaypal.vaultDeleteButtonCaption = vaultDeleteButtonCaption;
        BraintreePaypal.vaultDeleteConfirmationMessage = vaultDeleteConfirmationMessage;
        BraintreePaypal.vaultDeleteConfirmationButtonCaption = vaultDeleteConfirmationButtonCaption;

        BraintreePaypal.paypalTransactionType = paypalTransactionType;
        console.log('BraintreePaypal.paypalTransactionType: ' + BraintreePaypal.paypalTransactionType);

        if (BraintreePaypal.paypalTransactionType === BraintreePaypal.Constants.PaypalTransactionType.NO_PAYPAL_ALLOWED) {
            // For some reason paying with paypal in not supported, this object should not be used, exit.
            return;
        } else if (BraintreePaypal.paypalTransactionType === BraintreePaypal.Constants.PaypalTransactionType.NO_VAULT_AT_ALL) {
            // The user must complete the flow to login to his paypal account but he does not have the choice to store his
            // paypal credentials for future use (vault).
            BraintreePaypal.transactionStep = BraintreePaypal.Constants.NonVaultedTransactionStep.PAYPAL_BUTTON_NOT_INITIALIZED;
            BraintreePaypal.preapproveFuturePayments = false;
        } else if (BraintreePaypal.paypalTransactionType === BraintreePaypal.Constants.PaypalTransactionType.VAULT_CREATION) {
            // The user must complete the flow to login to his paypal account and his credentials will be stored for
            // future use (vault).
            BraintreePaypal.transactionStep = BraintreePaypal.Constants.NonVaultedTransactionStep.PAYPAL_BUTTON_NOT_INITIALIZED;
            BraintreePaypal.preapproveFuturePayments = true;
        } else if (BraintreePaypal.paypalTransactionType === BraintreePaypal.Constants.PaypalTransactionType.VAULT_REUSAGE) {
            // The user cannot complete the flow to login to his paypal account because his credentials had already been
            // stored in the past and now will be reused.
            BraintreePaypal.transactionStep = BraintreePaypal.Constants.VaultedTransactionStep.VAULTED_PAYMENT_UNVERIFIED;
            BraintreePaypal.paypalAccountEmail = paypalAccountEmail;
        }

        // BraintreePaypal.blockUiHandler = blockUiHandler;
        // BraintreePaypal.unblockUiHandler = unblockUiHandler;
        //BraintreePaypal.loginFlowLocale = loginFlowLocale;

        if (BraintreePaypal.paypalTransactionType === BraintreePaypal.Constants.PaypalTransactionType.NO_VAULT_AT_ALL
            || BraintreePaypal.paypalTransactionType === BraintreePaypal.Constants.PaypalTransactionType.VAULT_CREATION) {


            BraintreePaypal.key = key;
            BraintreePaypal.flowId = flowId;
            BraintreePaypal.paypalSaveEnabled = paypalSaveEnabled;
            BraintreePaypal.paypalClientToken = paypalClientToken;
            BraintreePaypal.amount = amount;

            BraintreePaypal.paypalLoginButtonElementId = paypalLoginButtonElementId;

            // INITIALIZE AND CREATE THE PAYPAL ACCOUNT LOGIN BUTTON
            BraintreePaypal.initializeBraintreePaypalLoginButton();

        } else if (BraintreePaypal.paypalTransactionType === BraintreePaypal.Constants.PaypalTransactionType.VAULT_REUSAGE) {
            BraintreePaypal.key = key;
            BraintreePaypal.flowId = flowId;
            BraintreePaypal.paypalSaveEnabled = paypalSaveEnabled;
            BraintreePaypal.paypalClientToken = paypalClientToken;
            BraintreePaypal.amount = amount;
            BraintreePaypal.vaultDeleteButtonCaption = vaultDeleteButtonCaption;
            BraintreePaypal.vaultDeleteButtonYes = vaultDeleteButtonYes;
            BraintreePaypal.vaultDeleteButtonNo = vaultDeleteButtonNo;
            // BraintreePaypal.initializePaypalButtonActionURL = initializePaypalButtonActionURL;
            // BraintreePaypal.deletVaultActionURL = deletVaultActionURL;
            console.log('beforeSend of initializePaypalButton (VAULT_REUSAGE)');
            console.log("initializePaypalButton returned (success handler)");

            // RUN BRAINTREE SETUP JUST TO GET THE DEVICE DATA...
            braintree.setup(paypalClientToken, "custom", {
                dataCollector: {
                    paypal: true
                },

                onReady: function (braintreeInstance) {

                    BraintreePaypal.braintreeInstance = braintreeInstance;

                    BraintreePaypal.deviceData = braintreeInstance.deviceData;
                    sessionStorage.setItem('deviceData', braintreeInstance.deviceData);
                    console.log("BraintreePaypal.deviceData: " + BraintreePaypal.deviceData);
                },

                onError: function(error){
                    console.log("initializePaypalButtonActionURL returned (error handler) data: " + Cognity.Utils.objectToString(error));
                }
            });



            var emailDiv = '<div id="braintree-paypal-loggedin" style="display: block; max-width: 500px; overflow: hidden; padding: 16px; background-image: url(https://checkout.paypal.com/pwpp/2.18.0/images/paypal-small.svg), none; background-position: 20px 50%; background-repeat: no-repeat; background-size: 13px 15px; border-top: 1px solid rgb(209, 212, 214); border-bottom: 1px solid rgb(209, 212, 214);">'
                + '<span id="bt-pp-name" style="color: rgb(40, 48, 54); font-size: 13px; font-weight: 800; margin-left: 36px;">PayPal</span>'
                + '<span id="bt-pp-email" style="color: rgb(110, 120, 127); font-size: 13px; margin-left: 25px;">'
                + BraintreePaypal.paypalAccountEmail + '</span><span style="float:right"><a id="paypaDeleteVault">' + BraintreePaypal.vaultDeleteButtonCaption + '</a></span></div>'

            // INSTEAD OF THE PAYPAL LOGIN BUTTON PUT THE USERS PAYPAL ACCOUNT EMAIL BESIDE THE PAYPAL PAYMENT METHOD RADIO BUTTON SELECTION.
            $('#'+paypalLoginButtonElementId).html(emailDiv);


            $( "#paypaDeleteVault" ).click(function() {

                Alerts.showConfirmation(BraintreePaypal.vaultDeleteButtonYes,BraintreePaypal.vaultDeleteButtonNo,"", BraintreePaypal.vaultDeleteConfirmationMessage , BraintreePaypal.vaultDeleteConfirmationButtonCaption , function(dialogResponse) {

                    if (dialogResponse){ // dialogResponse: If user pressed yes then truthy else falsy...

                        console.log('paypaDeleteVault, confirmation button, response: yes');
                        BraintreePaypal.deleteVault();
                        // Must reload the page so that GuestAvtController.initializePaypalLoginButton
                        // can reset the session step to PAYPAL_BUTTON_INITIALIZED.
                        //location.reload(true);

                    } else {

                        console.log('paypaDeleteVault, confirmation button, response: yes');
                        // do nothing
                    }
                });

            });

            $("#paypalLoginButton").removeClass("paypalLoginButton");
            $(".paymentMethodBRAINTREE_PAYPALCheckBox").removeClass("paymentMethodBRAINTREE_PAYPALshilftClass");

        }

    },

    initializeBraintreePaypalLoginButton: function(){

                    // SUCCESS
                    // Create the paypal button.
                    braintree.setup(
                        BraintreePaypal.paypalClientToken,
                        "custom",
                        {
                            paypal: {
                                singleUse: !BraintreePaypal.preapproveFuturePayments,
                                container: "paypalLoginButton",
                                //locale: BraintreePaypal.loginFlowLocale,
                                amount: BraintreePaypal.amount,
                                currency: "EUR",
                                //headless: true,
                                enableBillingAddress: true,
                                onCancelled: function(obj) {

                                    //$("#paypalLoginButton").addClass("paypalLoginButton");
                                    //$(".paymentMethodBRAINTREE_PAYPALCheckBox").addClass("paymentMethodBRAINTREE_PAYPALshilftClass");


                                    console.log("Paypal login was cancelled by user.");
                                    // Must reload the page so that GuestAvtController.initializePaypalLoginButton
                                    // can reset the session step to PAYPAL_BUTTON_INITIALIZED.
                                    window.location.reload(true);
                                }
                            },

                            dataCollector: { // This is needed to collect the deviceData.
                                paypal: true
                            },

                            onPaymentMethodReceived: function(paymentDescriptor) {

                                //$("#paypalLoginButton").removeClass("paypalLoginButton");
                                //$(".paymentMethodBRAINTREE_PAYPALCheckBox").removeClass("paymentMethodBRAINTREE_PAYPALshilftClass");

                                console.log('onPaymentMethodReceived');
                                console.log("nonce: "+paymentDescriptor.nonce);
                                console.log("type: "+paymentDescriptor.type);
                                console.log("details.email: "+paymentDescriptor.details.email);
                                console.log("details.firstName: "+paymentDescriptor.details.firstName);
                                console.log("details.lastName: "+paymentDescriptor.details.lastName);
                                console.log("details.payerId: "+paymentDescriptor.details.payerId);
                                console.log("paymentDescriptor: "+Cognity.Utils.recursiveStringify(paymentDescriptor));
                                console.log(paymentDescriptor);
                                sessionStorage.setItem('nonce', paymentDescriptor.nonce);
                                console.log(paymentDescriptor.nonce);
                                BraintreePaypal.paymentDescriptor = paymentDescriptor;
                                sessionStorage.setItem('payerEmail', paymentDescriptor.details.email);
                                // Make sure that the paypal payment method and corresponding radio button is selected.
                                BraintreePaypal.selectedPaymentMethod = BraintreePaypal.Constants.PaymentMethod.BRAINTREE_PAYPAL;

                                // Login to paypal has completed successfully, inform the back end.
                                BraintreePaypal.completePaypalLogin();
                            },

                            onReady: function (braintreeInstance) {

                                BraintreePaypal.braintreeInstance = braintreeInstance;

                                BraintreePaypal.deviceData = braintreeInstance.deviceData;
                                console.log('braintree.setup onReady');
                                console.log(braintreeInstance);
                                console.log("braintree.setup Device Data: " + braintreeInstance.deviceData);
                                sessionStorage.setItem('deviceData', braintreeInstance.deviceData);
                                BraintreePaypal.paypal = braintreeInstance.paypal;
                                console.log('initialized: braintreeInstance.paypal' + braintreeInstance.paypal);

                                // Bind the initiatePaypalLogin click listener on the paypalLoginButtonElementId element
                                // that has just been initialized.
                                $('#'+BraintreePaypal.paypalLoginButtonElementId).click(function(){
                                    console.log('paypalLoginButtonElementId handler for initiatePaypalLogin called!!!');

                                    if( BraintreePaypal.transactionStep === BraintreePaypal.Constants.NonVaultedTransactionStep.PAYPAL_BUTTON_INITIALIZED){
                                        BraintreePaypal.initiatePaypalLogin();
                                    }
                                });
                                // braintree.setup has completed:
                                BraintreePaypal.transactionStep =
                                    BraintreePaypal.Constants.NonVaultedTransactionStep.PAYPAL_BUTTON_INITIALIZED;
                            },

                            onError: function(error){
                                console.log("braintree.setup onError called, error object: " +
                                    Cognity.Utils.objectToString(error));

                                BraintreePaypal.transactionStep =
                                    BraintreePaypal.Constants.NonVaultedTransactionStep.PAYPAL_BUTTON_NOT_INITIALIZED;
                            }
                        }
                    );

    },

    initiatePaypalLogin : function(){

        console.log('start initiatePaypalLogin ...');

        $.ajax({
            type : 'POST',
            url : process.env.REACT_APP_PAYPAL_LOGIN_INIT,
            dataType: 'json',
            contentType: 'application/json',
            headers: { "Authorization": sessionStorage.getItem('token') },
            data : JSON.stringify({
                'flowId': BraintreePaypal.flowId,
                'key': BraintreePaypal.key,
                'paypalSaveEnabled': BraintreePaypal.paypalSaveEnabled
            }),

            success : function(data) {
                // log response
                console.log("initiatePaypalLogin returned (success handler) data: " + Cognity.Utils.objectToString(data));

                if(data){

                    sessionStorage.setItem('transactionToken', data.transactionToken);

                    console.log("initiatePaypalLogin success handler returned SUCCESS!!!");
                    BraintreePaypal.transactionStep =
                        BraintreePaypal.Constants.NonVaultedTransactionStep.PAYPAL_LOGIN_INITIATED;

                    // Handle the case when GuestAvtController.initiatePaypalLogin had not completed yet but
                    // the user had finished the paypal login flow. In that case GuestAvtController.completePaypalLogin
                    // could not have been called at that moment and must be called now.
                    if(BraintreePaypal.mustCompletePaypalLogin){
                        BraintreePaypal.completePaypalLogin();
                    }

                }else {
                    console.log("initiatePaypalLogin success handler returned unknown status or no data or status, check your code!!!");
                }
            },

            error : function(data) {
                console.log("submitPayment returned (error handler) data: "+Cognity.Utils.objectToString(data));
            }
        });
    },

    completePaypalLogin : function(){

        // Handle the case when GuestAvtController.initiatePaypalLogin had not completed yet but
        // the user had finished the paypal login flow. completePaypalLogin will be called but
        // it must not execute. It must execute only the following if and set BraintreePaypal.mustCompletePaypalLogin = true.
        // This way it can be called when initiatePaypalLogin completes the ajax call.
        if( BraintreePaypal.mustCompletePaypalLogin === false &&
            BraintreePaypal.transactionStep !== BraintreePaypal.Constants.NonVaultedTransactionStep.PAYPAL_LOGIN_INITIATED){

            BraintreePaypal.mustCompletePaypalLogin = true;
            return;
        }

        var countryCodeAlpha2 = 'DATA_NOT_RECEIVED';
        if(BraintreePaypal.paymentDescriptor && BraintreePaypal.paymentDescriptor.details && BraintreePaypal.paymentDescriptor.details.billingAddress && BraintreePaypal.paymentDescriptor.details.billingAddress.countryCodeAlpha2){
            countryCodeAlpha2 = BraintreePaypal.paymentDescriptor.details.billingAddress.countryCodeAlpha2;
            console.log('found billingAddress.countryCodeAlpha2:'+ countryCodeAlpha2);

        }else{
            console.log(
                'countryCodeAlpha2 ... DATA_NOT_RECEIVED, CognityUtils.recursiveStringify'+
                '(BraintreePaypal.paymentDescriptor)'+Cognity.Utils.recursiveStringify(BraintreePaypal.paymentDescriptor));
        }
        console.log(BraintreePaypal.paymentDescriptor);

        console.log("completePaypalLogin, countryCodeAlpha2:"+ countryCodeAlpha2);

        $.ajax({
            type : 'POST',
            url : process.env.REACT_APP_PAYPAL_LOGIN_COMPLETE,
            dataType: 'json',
            contentType: 'application/json',
            headers: { "Authorization": sessionStorage.getItem('token') },
            data : JSON.stringify({
                'key': BraintreePaypal.key,
                'transactionToken': sessionStorage.getItem('transactionToken'),
                'paymentNonce' : BraintreePaypal.paymentDescriptor.nonce,
                // paymentType : BraintreePaypal.paymentDescriptor.type, // we don't need that info (will be just 'paypal' or something like that...)
                'paypalEmail' : BraintreePaypal.paymentDescriptor.details.email,
                'paypalFirstName' : BraintreePaypal.paymentDescriptor.details.firstName,
                'paypalLastName' : BraintreePaypal.paymentDescriptor.details.lastName,
                'paypalPayerId' : BraintreePaypal.paymentDescriptor.details.payerId,
                'paypalCountryCode': countryCodeAlpha2,
                'flowId': BraintreePaypal.flowId,
                'deviceData': sessionStorage.getItem('deviceData')
            }),

            beforeSend: function() {

                console.log('beforeSend of completePaypalLogin action AJAX call called.');
            },

            success : function(data) {

                sessionStorage.setItem('completeData', data);

                // log response
                console.log("completePaypalLogin returned (success handler) data: "+Cognity.Utils.objectToString(data));

                if (data) {
                    console.log("completePaypalLogin, success handler, returned SUCCESS !!!");
                    BraintreePaypal.transactionStep =
                        BraintreePaypal.Constants.NonVaultedTransactionStep.PAYPAL_LOGIN_COMPLETED;
                    document.querySelector('#paypal_login_completed').innerHTML = true;
                }else {
                    console.log("completePaypalLogin, success handler, returned unknown status or no status, check your code !!!");
                }
            },

            error : function(data) {
                console.log("completePaypalLogin returned (error handler) data: "+Cognity.Utils.objectToString(data));
            }
        });
    },
    deleteVault : function(){
        console.log('start deleteVault ...');

        $.ajax({
            type : 'POST',
            url : process.env.REACT_APP_VAULT_DELETE,
            dataType: 'json',
            contentType: 'application/json',
            headers: { "Authorization": sessionStorage.getItem('token') },
            data : JSON.stringify({
                paypalEmail:sessionStorage.getItem('vaultEmail'),
                vaultId: sessionStorage.getItem('vaultId'),
            }),

            success : function(data) {
                // log response
                console.log("deleteVault returned (success handler) data: " + Cognity.Utils.objectToString(data));

                if(data && data.code === 0){

                    console.log("deleteVault success handler returned SUCCESS!!!");
                    window.location.reload(true);

                }else {
                    console.log("deleteVault success handler returned unknown status or no data or status, check your code!!!");
                }
            },

            error : function(data) {
                console.log("deleteVault returned (error handler) data: "+Cognity.Utils.objectToString(data));
                window.location.reload(true);
            }
        });
    }


};